<script lang="ts">
	//Design system components
	import { Alert, Button } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { isGen2EM, isProThreeEM } from 'src/helpers/interface_helpers';

	export let device;

	let loading = false;

	const deleteData = async () => {
		loading = true;
		const method =
			isGen2EM(device?.type) || (isProThreeEM(device?.type) && device.mode === 'monophase')
				? 'EM1Data.DeleteAllData'
				: 'EMData.DeleteAllData';
		const res = await gen2Request(device, method, {
			id: device.channel,
		});

		await onSettingsResponse(res, device, {
			success: $format('erase_data_scc_toast', {
				default: `Device's data was erased successfully!`,
			}),
			danger: $format('error_global'),
		});
		loading = false;
	};
</script>

<Alert
	class="mb-s"
	heading={$format('delete_stored_metrics_description', {
		default: 'Delete stored metrics from the device.',
	})}
/>

<Button {loading} width="full" size="m" on:click={deleteData}>{$format('button_delete')}</Button>
